import { markdownToSanitizedHTML } from '../markdown-to-html/markdownToSanitizedHTML';

const collapseBlankLineRuns = (text: string): string =>
  text.replace(/\n{3,}/g, '\n\n');

const markdownToTextPreview = (markdownText: string): string =>
  collapseBlankLineRuns(
    new DOMParser().parseFromString(
      markdownToSanitizedHTML(markdownText.slice(0, 500), 'permissive'),
      'text/html'
    ).documentElement.textContent || ''
  );

export { markdownToTextPreview };
